import { render, staticRenderFns } from "./brandBuild.vue?vue&type=template&id=2ff724d9&scoped=true"
import script from "./brandBuild.vue?vue&type=script&lang=js"
export * from "./brandBuild.vue?vue&type=script&lang=js"
import style0 from "./brandBuild.vue?vue&type=style&index=0&id=2ff724d9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff724d9",
  null
  
)

export default component.exports